
(function () {
  'use strict';
  if (window.__megaFlyoutInit) return;
  window.__megaFlyoutInit = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function createSlider(list) {
    var slider = document.createElement('span');
    slider.className = 'mega-flyout__slider';
    slider.setAttribute('aria-hidden', 'true');
    list.appendChild(slider);

    function place(li) {
      slider.style.top = li.offsetTop + 'px';
      slider.style.height = li.offsetHeight + 'px';
    }

    return {
      move: function (li) {
        if (!li) {
          slider.classList.remove('is-visible');
          return;
        }
        if (slider.classList.contains('is-visible')) {
          place(li);
        } else {
          slider.style.transition = 'none';
          place(li);
          void slider.offsetHeight;
          slider.style.transition = '';
          slider.classList.add('is-visible');
        }
      },
      hide: function () {
        slider.classList.remove('is-visible');
      },
      visible: function () {
        return slider.classList.contains('is-visible');
      }
    };
  }

  function setup(root) {
    if (root.dataset.flyoutReady === 'true') return;
    root.dataset.flyoutReady = 'true';
    root.classList.add('mega-flyout--slide');

    var catTriggers = Array.prototype.slice.call(root.querySelectorAll('[data-cat-trigger]'));
    var subTriggers = Array.prototype.slice.call(root.querySelectorAll('[data-sub-trigger]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cat-panel]'));
    var tileSets = Array.prototype.slice.call(root.querySelectorAll('[data-tile-set]'));
    if (!catTriggers.length) return;

    /* ---------- sliding pills ---------- */
    var catList = root.querySelector('.mega-flyout__categories');
    var catSlider = catList ? createSlider(catList) : null;

    panels.forEach(function (p) {
      p.__slider = createSlider(p);
      p.addEventListener('mouseleave', function () {
        p.__slider.hide();
      });
    });

    function activeCatLi() {
      var a = root.querySelector('[data-cat-trigger].is-active');
      return a ? a.closest('li') : null;
    }

    function hidePanelSliders() {
      panels.forEach(function (p) {
        p.__slider.hide();
      });
    }

    root.addEventListener('mouseenter', function () {
      if (catSlider && !catSlider.visible()) catSlider.move(activeCatLi());
    });
    root.addEventListener('focusin', function () {
      if (catSlider && !catSlider.visible()) catSlider.move(activeCatLi());
    });
    if (catList && catSlider) {
      catList.addEventListener('mouseleave', function () {
        catSlider.move(activeCatLi());
      });
    }

    /* ---------- adaptive width engine ----------
       The panel hugs its content. Geometry rules that make this safe:
       1. The panel's LEFT edge is anchored at the offset that centres the
          widest possible state. Width changes only ever move the RIGHT
          edge, so the promo card and every pill occupy fixed positions
          for the whole lifetime of the menu. The element under the
          cursor can never move as a result of a hover — thrash is
          impossible by construction.
       2. Panel, sub column and featured zone all transition width with
          the SAME duration + easing started in the same frame, so the
          sum of the parts equals the panel width on every animation
          frame, including when interrupted by fast hovering.
       3. Gaps and paddings are MEASURED from computed style, never
          assumed; the available width is recomputed on every apply; and
          a post-transition verification pass re-measures and re-applies
          if any invariant is violated — the layout is self-healing. */
    var subcol = root.querySelector('.mega-flyout__subcol');
    var featured = root.querySelector('.mega-flyout__featured');

    function subWidth(panel) {
      if (!panel) return 0;
      var w = parseFloat(getComputedStyle(panel).width);
      return isNaN(w) ? 0 : w;
    }

    function createAdaptive() {
      root.classList.add('mega-flyout--adaptive');

      var nav = root.querySelector('.mega-flyout__nav');
      var catsRight = 0; /* panel left edge -> right edge of category column */
      var maxTiles = 0;  /* widest tile set at the current viewport */
      var maxSub = 0;    /* widest sub-link column */
      var anchorPx = 0;  /* fixed left margin centring the widest state */
      /* measured live so theme CSS the model doesn't know about
         (residual gaps, paddings) can never desync the arithmetic */
      var padR = 5, navGap = 0, rootGap = 0, subPad = 0, featPad = 0;
      var availW = 0;

      function gapOf(el) {
        if (!el) return 0;
        var g = parseFloat(getComputedStyle(el).columnGap);
        return isNaN(g) ? 0 : g;
      }
      function padXOf(el) {
        if (!el) return 0;
        var cs = getComputedStyle(el);
        return (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
      }

      function measure() {
        var pr = root.getBoundingClientRect();
        var cr = catList.getBoundingClientRect();
        catsRight = cr.right - pr.left;

        padR = parseFloat(getComputedStyle(root).paddingRight) || 0;
        navGap = gapOf(nav);
        rootGap = gapOf(root);
        subPad = padXOf(subcol);
        featPad = padXOf(featured);

        maxTiles = 0;
        tileSets.forEach(function (s) {
          var w = s.offsetWidth; /* width:max-content -> natural size */
          if (w > maxTiles) maxTiles = w;
        });

        maxSub = 0;
        panels.forEach(function (p) {
          var w = subWidth(p); /* computed style works on display:none */
          if (w > maxSub) maxSub = w;
        });

        var wrap = root.closest('.header--menu-submenu') || root.parentElement;
        var avail = 0;
        if (wrap) {
          var cs = getComputedStyle(wrap);
          /* clamp against the document width so a content-box wrapper
             (width:100% + padding) cannot inflate the available space */
          var wrapW = Math.min(wrap.clientWidth, document.documentElement.clientWidth);
          avail = wrapW - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
        }
        availW = avail;
        var maxW = catsRight
          + (maxSub ? navGap + 24 + maxSub + subPad : 0)
          + (maxTiles ? rootGap + 21 + maxTiles + featPad : 0)
          + padR;
        if (avail > 0) maxW = Math.min(maxW, avail);
        maxW = Math.min(maxW, 1400);
        anchorPx = Math.max((avail - maxW) / 2, 0);
      }

      function freshAvail() {
        var wrap = root.closest('.header--menu-submenu') || root.parentElement;
        if (!wrap) return availW;
        var wcs = getComputedStyle(wrap);
        var wrapW = Math.min(wrap.clientWidth, document.documentElement.clientWidth);
        return wrapW - (parseFloat(wcs.paddingLeft) || 0) - (parseFloat(wcs.paddingRight) || 0);
      }

      function apply(instant, isRetry) {
        var activePanel = root.querySelector('.mega-flyout__subs.is-active');
        var activeSet = root.querySelector('.mega-flyout__tileset.is-active');
        var subW = subWidth(activePanel);
        var featW = activeSet ? activeSet.offsetWidth : 0;
        /* outer box of each column = content + its own residual padding */
        var subOuter = subW ? subW + subPad : 0;
        var featOuter = featW ? featW + featPad : 0;
        var panelW = catsRight
          + (subOuter ? navGap + 24 + subOuter : 0)
          + (featOuter ? rootGap + 21 + featOuter : 0)
          + padR;
        /* never exceed the wrapper: shrink the featured zone to absorb any
           deficit so the clip lands on the panel's own edge, not off-panel.
           availW is recomputed here (cheap) so a missed resize event can
           never cap against a stale value; anchorPx stays cached so pills
           never move mid-interaction. */
        availW = freshAvail();
        var room = availW - anchorPx;
        if (availW > 0 && panelW > room) {
          featOuter = Math.max(featOuter - (panelW - room), 0);
          panelW = room;
        }

        var els = [root, subcol, featured];
        var snap = instant || REDUCED.matches;
        if (snap) {
          els.forEach(function (el) {
            if (el) el.style.transition = 'none';
          });
        }

        root.style.marginLeft = anchorPx + 'px';
        root.style.width = panelW + 'px';
        if (subcol) {
          subcol.style.width = subOuter + 'px';
          subcol.style.marginLeft = (subOuter ? 24 : 0) + 'px';
        }
        if (featured) {
          featured.style.width = featOuter + 'px';
          featured.style.marginLeft = (featOuter ? 21 : 0) + 'px';
        }

        if (snap) {
          void root.offsetHeight;
          els.forEach(function (el) {
            if (el) el.style.transition = '';
          });
        }
        if (!isRetry) verify();
      }

      /* self-healing: after the transition settles, confirm the geometry
         invariants (tiles inside the panel, panel hugging the featured
         zone, panel inside the wrapper). Any violation — whatever the
         cause — triggers one full re-measure + instant re-apply. */
      var vT = null;
      function verify() {
        clearTimeout(vT);
        vT = setTimeout(function () {
          if (!document.contains(root)) return;
          var pr = root.getBoundingClientRect();
          if (!pr.width) return; /* flyout hidden at this viewport */
          var edge = pr.right - padR;
          var fr = featured ? featured.getBoundingClientRect() : null;
          var set = root.querySelector('.mega-flyout__tileset.is-active');
          var sr = set ? set.getBoundingClientRect() : null;
          var wrap = root.closest('.header--menu-submenu');
          var wrapEdge = Infinity;
          if (wrap) {
            var wcs = getComputedStyle(wrap);
            wrapEdge = wrap.getBoundingClientRect().right - (parseFloat(wcs.paddingRight) || 0);
          }
          var bad =
            (sr && sr.right > edge + 1) ||
            (fr && fr.right > edge + 1) ||
            (fr && fr.width > 0 && edge - fr.right > 1) ||
            pr.right > wrapEdge + 1;
          if (bad) {
            measure();
            apply(true, true);
          }
        }, 420);
      }

      var rT = null;
      function scheduleRemeasure() {
        clearTimeout(rT);
        rT = setTimeout(function () {
          if (!document.contains(root)) return;
          measure();
          apply(true);
        }, 120);
      }
      window.addEventListener('resize', scheduleRemeasure);
      /* a scrollbar appearing or disappearing (e.g. images lazy-loading
         on long pages) changes the available width WITHOUT firing a
         window resize; observing the document element catches it, so
         late-loading content can never strand a stale anchor */
      if (typeof ResizeObserver !== 'undefined') {
        new ResizeObserver(scheduleRemeasure).observe(document.documentElement);
      }

      measure();
      apply(true);

      return {
        refresh: function () {
          apply(false);
        }
      };
    }

    var adaptive = (catList && featured) ? createAdaptive() : null;

    /* ---------- tile sets ---------- */
    function showTiles(key) {
      var matched = false;
      tileSets.forEach(function (s) {
        var on = s.getAttribute('data-tile-set') === key;
        s.classList.toggle('is-active', on);
        if (on) matched = true;
      });
      if (!matched) {
        tileSets.forEach(function (s) {
          s.classList.toggle('is-active', s.getAttribute('data-tile-set') === 'default');
        });
      }
    }

    function activateCategory(index, tileKey) {
      catTriggers.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-index') === index);
      });
      panels.forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-index') === index);
      });
      hidePanelSliders();
      showTiles(tileKey);
      if (adaptive) adaptive.refresh();
    }

    /* ---------- triggers ---------- */
    catTriggers.forEach(function (t) {
      var idx = t.getAttribute('data-index');
      var key = t.getAttribute('data-tiles') || 'default';
      function on() {
        activateCategory(idx, key);
        if (catSlider) catSlider.move(t.closest('li'));
      }
      t.addEventListener('mouseenter', on);
      t.addEventListener('focus', on);
      t.addEventListener('touchend', function (e) {
        var hasPanel = panels.some(function (p) { return p.getAttribute('data-index') === idx; });
        if (hasPanel && !t.classList.contains('is-active')) {
          e.preventDefault();
          on();
        }
      });
    });

    subTriggers.forEach(function (t) {
      var key = t.getAttribute('data-tiles') || 'default';
      function on() {
        showTiles(key);
        var panel = t.closest('[data-cat-panel]');
        if (panel && panel.__slider) panel.__slider.move(t.closest('li'));
        if (adaptive) adaptive.refresh();
      }
      t.addEventListener('mouseenter', on);
      t.addEventListener('focus', on);
    });
  }

  function initAll() {
    document.querySelectorAll('[data-mega-flyout]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
